// extracted by mini-css-extract-plugin
export default {"contactBrand":"ContactBrand_contactBrand__GalYZ","container":"ContactBrand_container__sFGLl","content":"ContactBrand_content__Hrb7T","button":"ContactBrand_button__aKiRy"};